module.exports = "/images/SetUpYourCompany-5.jpg";